import * as _ from 'lodash';
import {
  UPLOAD_ADD,
  UPLOAD_DELETE,
  UploadHookActionTypes,
} from './upload-hook-action-types';

export interface Upload {
  uuid: string;
  files: File[];
  fileNameUrlMap: Map<string, string>;
}

interface UploadState {
  uploads: Upload[];
}

const initialState: UploadState = {
  uploads: [],
};

const uploadHookReducer = (state = initialState, action: UploadHookActionTypes): UploadState => {
  const uploads: Upload[] = _.cloneDeep(state.uploads);

  switch (action.type) {
    case UPLOAD_ADD:
      uploads.push({ uuid: action.uuid, files: action.files, fileNameUrlMap: action.fileNameUrlMap });
      return { ...state, uploads };

    case UPLOAD_DELETE: {
      const uploadsRemoved: Upload[] = _.remove(uploads, (upload: Upload) => upload.uuid !== action.uuid);
      return { ...state, uploads: uploadsRemoved };
    }

    default:
      return state;
  }
};

export default uploadHookReducer;
